import { useEffect, useRef } from "react"

import { getDates } from "../../../Utils/utils"

/**
 * Custom hook for fetching Health data with pagination and filters
 * Handles automatic data fetching when dependencies change
 */
export const useHealthDataFetch = ({
  filters,
  businessId,
  pageNumber,
  pageSize,
  ordering,
  fetchAction,
  dataSource
}) => {
  const helpRef = useRef({ firstLoading: true })

  useEffect(() => {
    if (filters?.period) {
      const period_query = getDates(filters.period)
      fetchAction({
        page: pageNumber,
        page_size: pageSize,
        ordering,
        business_account: businessId,
        ...(dataSource ? { source: dataSource } : {}),
        ...period_query
      })

      if (helpRef.current.firstLoading) {
        helpRef.current.firstLoading = false
      }
    }
  }, [filters?.period, businessId, ordering, pageNumber, pageSize, fetchAction, dataSource])

  return { isFirstLoading: helpRef.current.firstLoading }
}
